module.exports = __webpack_public_path__ + "img/icon_pay_success.430f0e09.png";